"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBuiltInLabelCategory = void 0;
const BuiltInLabelCategories = ['certification', 'warning', 'sensitivity'];
function isBuiltInLabelCategory(category) {
    return BuiltInLabelCategories.includes(category.toLowerCase());
}
exports.isBuiltInLabelCategory = isBuiltInLabelCategory;
//# sourceMappingURL=LabelCategories.js.map